var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 223 236",
  width: 32,
  className: "angular_svg__angular-logo"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#angular_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#angular_svg__b)",
  d: "m222.077 39.192-8.019 125.923L137.387 0l84.69 39.192Zm-53.105 162.825-57.933 33.056-57.934-33.056 11.783-28.556h92.301l11.783 28.556ZM111.039 62.675l30.357 73.803H80.681l30.358-73.803ZM7.937 165.115 0 39.192 84.69 0 7.937 165.115Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#angular_svg__c)",
  d: "m222.077 39.192-8.019 125.923L137.387 0l84.69 39.192Zm-53.105 162.825-57.933 33.056-57.934-33.056 11.783-28.556h92.301l11.783 28.556ZM111.039 62.675l30.357 73.803H80.681l30.358-73.803ZM7.937 165.115 0 39.192 84.69 0 7.937 165.115Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "angular_svg__b",
  x1: 49.009,
  x2: 225.829,
  y1: 213.75,
  y2: 129.722,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E40035"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#F60A48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.352,
  stopColor: "#F20755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.494,
  stopColor: "#DC087D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.745,
  stopColor: "#9717E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C00F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "angular_svg__c",
  x1: 41.025,
  x2: 156.741,
  y1: 28.344,
  y2: 160.344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF31D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5BE1",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "angular_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h223v236H0z"
})))));
export { SvgAngular as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/angular.svg";